export default __webpack_public_path__ + "static/media/EOT CRANE ACCIDENT SIMULATOR.347bdc44.JPG";